const transformFeatureData = featureData => {
  const data = featureData.reduce((object, item) => {
    const key = item.layer.id
    object[key] = (object[key] || []).concat(item.properties)
    return object
  }, {})

  return data
}

export default transformFeatureData



// WEBPACK FOOTER //
// ./src/utility/transformFeatureData.js